export const gallerySectionHighRiseMidRiseProjects =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/1.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/2.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/3.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/4.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/5.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/6.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0004HighRiseMidRiseProjects/7.jpg",
            "rowSpan": 2,
            "colSpan": 2
        }
    ]

}